import { connect } from 'react-redux';
import { change, formValueSelector } from 'redux-form';
import { formName, US_TERRITORIES } from '../Constants/constants';
import {
  editForm,
  confirmForm,
  VENUE_FORM,
  venuePresets,
  clearVenueSearchForm,
  shouldLookupTax,
  clearRegionsList,
  updateVenueInputSelect,
  searchByVenueCode,
  resetVenueCodeValidation,
  clearSelectPlace,
  clearSpecialTaxForms,
  getCoordsForUtc,
  setKentuckyCity as setKentuckyCityAction,
  setUtcOffset,
  setSelectedVenueCode,
  setValidVenueAddressAndState,
  defaultBasicCoverageOptions,
  defaultAdditionalCoverageStatus,
  defaultAdditionalCoveragesForm,
  updateManualAddress,
  updateManualAddressCity,
  getAdditionalCertHolders,
  startLoading,
  GET_ADDITIONAL_CERT_HOLDERS,
} from '../Actions/actions';
import {
  setIsKentuckyCity,
  setKentuckyCity,
  setHasLookedUpTax,
  setVenueSearchReadOnly,
} from '../Actions/venue';
import Venue from '../Components/Venue/Venue';
import Debounce from '../Helpers/Debounce';
import initialFormValues from '../Constants/initialFormValues';
import { addressTypeIsForAddress } from '../Helpers/AddressTypes';
import { BY_SEARCH } from '../Constants/venueSearchTypes';

const debounce = new Debounce({ period: 500 });

const formValues = formValueSelector(formName);

const mapStateToProps = (state) => {
  const { usStates } = state.formPage;

  const searchCountries = usStates.reduce(
    function getCountries(p, c) {
      if (US_TERRITORIES.indexOf(c.code) !== -1) {
        p.push(c.code.toLowerCase());
      }
      return p;
    },
    ['us'],
  );

  return {
    enabled: state.formPage.venue.enabled,
    confirmed: state.formPage.venue.confirmed,
    venue:
      state.formPage.venue.selectedPlaceAddressComponents.companyName || '',
    validVenue: state.formPage.venue.validVenue,
    hasInput: !!formValues(state, 'venue'),
    placeId: state.formPage.venue.selectedPlaceId || '',
    address: state.formPage.venue.selectedPlaceAddress,
    addressComponents: state.formPage.venue.selectedPlaceAddressComponents,
    mobile: state.formPage.summary.mobileDisplay,
    venueAddress1: state.formPage.venue.selectedPlaceAddressComponents.address1,
    venueCity: state.formPage.venue.selectedPlaceAddressComponents.city,
    venueState: state.formPage.venue.selectedPlaceAddressComponents.state || '',
    venueCountry: state.formPage.venue.selectedPlaceAddressComponents.country,
    venueZip: state.formPage.venue.selectedPlaceAddressComponents.zip,
    venueAddressType:
      state.formPage.venue.selectedPlaceAddressComponents.addressType,
    usStates,
    hasRegionalTax: state.formPage.venue.hasRegionalTax,
    taxRegions: state.formPage.venue.taxRegions,
    isKentuckyEntity: state.formPage.venue.isKentuckyEntity,
    venueMunicipalityCode: formValues(state, 'venueMunicipalityCode'),
    venueSelectInputOptions: state.formPage.venueSelectInputOptions,
    venueSearchTypeRadio: formValues(state, 'venueSearchTypeRadio'),
    facilityCode: formValues(state, 'facilityCode'),
    venueCode: formValues(state, 'venueCode'),
    venueName:
      state.formPage.venue.selectedPlaceAddressComponents.companyName || '',
    venueCodeChecked: state.formPage.venue.venueCodeChecked || false,
    validVenueCode: state.formPage.venue.validVenueCode || false,
    manualVenueAddress: {
      companyName: formValues(state, 'manualVenueName'),
      address1: formValues(state, 'manualVenueAddress1'),
      city: formValues(state, 'manualVenueCity'),
      state: formValues(state, 'manualVenueState'),
      zip: formValues(state, 'manualVenueZip'),
      country: formValues(state, 'manualVenueCountry'),
    },
    validManualAddress:
      state.formPage.venue.validManualAddress &&
      (state.formPage.venue.hasRegionalTax
        ? !!formValues(state, 'federalEntity') &&
          !!formValues(state, 'kentuckyStateEntity')
        : true),
    federalEntity: formValues(state, 'federalEntity'),
    kentuckyStateEntity: formValues(state, 'kentuckyStateEntity'),
    isKentuckyCity: state.formPage.venue.isKentuckyCity,
    kentuckyCity: state.formPage.venue.kentuckyCity,
    hasLookedUpTax: state.formPage.venue.hasLookedUpTax,
    venueSearchReadOnly: state.formPage.venue.venueSearchReadOnly,
    isBlocked: state.formPage.venue.isBlocked,
    genericServerError: state.formPage.venue.genericServerError,
    searchCountries,
  };
};

const mapDispatchToProps = (dispatch) => ({
  edit: () => dispatch(editForm(VENUE_FORM)),
  confirm: () => {
    return dispatch(confirmForm(VENUE_FORM));
  },
  venueInputSelect: (event) =>
    dispatch(updateVenueInputSelect(event.target.value)),
  onSelect: (
    _,
    placeId,
    address,
    addressComponents,
    utcOffset,
    setIsKentuckyCity,
    setHasLookedUpTax,
    setVenueSearchReadOnly,
  ) => {
    dispatch(startLoading(GET_ADDITIONAL_CERT_HOLDERS));
    dispatch(
      venuePresets(
        placeId,
        address,
        addressComponents,
        utcOffset,
        setIsKentuckyCity,
        setHasLookedUpTax,
        setVenueSearchReadOnly,
      ),
    );
  },
  isValidAddress: (
    venueAddress1,
    venueCity,
    venueState,
    venueCountry,
    venueZip,
    venueAddressType,
  ) =>
    !!(
      // Evaluate address type if it is supplied
      (
        (!venueAddressType || addressTypeIsForAddress(venueAddressType)) &&
        venueAddress1 &&
        venueCity &&
        venueState &&
        venueCountry &&
        venueZip
      )
    ),

  clearForm: (setVenueSearchReadOnly) => {
    dispatch(clearVenueSearchForm());
    dispatch(clearSpecialTaxForms());
    dispatch(clearRegionsList());
    dispatch(clearSelectPlace());
    dispatch(defaultBasicCoverageOptions());
    dispatch(defaultAdditionalCoverageStatus());
    dispatch(defaultAdditionalCoveragesForm());
    dispatch(
      change(
        formName,
        'generalLiabilityCoverage',
        initialFormValues().generalLiabilityCoverage,
      ),
    );
    setVenueSearchReadOnly(false);
  },
  isValidState: (venueState, usStates) => {
    let isValidState = false;
    usStates.some((e) => {
      if (e.code === venueState) {
        isValidState = true;
      }
      return e.code === venueState;
    });

    return isValidState;
  },
  searchVenueCode: (facilityCode, venueCode) => {
    dispatch(clearSelectPlace());
    dispatch(clearSpecialTaxForms());
    dispatch(clearRegionsList());

    if (
      facilityCode.length > 2 &&
      venueCode.length >= 3 &&
      venueCode.length <= 5
    ) {
      dispatch(startLoading(GET_ADDITIONAL_CERT_HOLDERS));
      dispatch(searchByVenueCode({ facilityCode, venueCode }));
      dispatch(getAdditionalCertHolders(`${facilityCode}-${venueCode}`));
    } else {
      dispatch(resetVenueCodeValidation());
      dispatch(setSelectedVenueCode());
    }
    dispatch(setValidVenueAddressAndState());
  },
  lookupTax: (
    state,
    city,
    setIsKentuckyCity,
    setHasLookedUpTax,
    // Optionally clear dependent form parts as well
    clear = true,
  ) => {
    debounce.do(() => {
      if (clear) {
        dispatch(clearRegionsList());
        dispatch(clearSpecialTaxForms());
      }
      if (state && city) {
        dispatch(
          shouldLookupTax(
            state,
            city,
            setIsKentuckyCity,
            setHasLookedUpTax,
            clear,
          ),
        );
      }
    });
  },
  lookupUtc: (zip) => {
    if (zip.length === 5) debounce.do(() => dispatch(getCoordsForUtc(zip)));
    else debounce.do(() => dispatch(setUtcOffset()));
  },
  setKentuckyCity: (city, federalEntity, kentuckyStateEntity) => {
    // Sets selected Kentucky city from radio list, replacing the user entered
    // value. But achange in 'manualVenueCity' resets user selection of federal
    // and state entities, these need to be preserved.
    dispatch(setKentuckyCityAction(city, federalEntity, kentuckyStateEntity));
  },
  setIsValidManualVenueAddress: (address) =>
    dispatch(setValidVenueAddressAndState(address)),
  setManualAddress: (address) => dispatch(updateManualAddress(address)),
  updateManualCity: (city) => dispatch(updateManualAddressCity(city)),
  setIsKentuckyCity: (isKentuckyCity) =>
    dispatch(setIsKentuckyCity(isKentuckyCity)),
  setFormKentuckyCity: (kentuckyCity) =>
    dispatch(setKentuckyCity(kentuckyCity)),
  setHasLookedUpTax: (hasLookedUpTax) =>
    dispatch(setHasLookedUpTax(hasLookedUpTax)),
  setVenueSearchReadOnly: (venueSearchReadOnly) =>
    dispatch(setVenueSearchReadOnly(venueSearchReadOnly)),
});

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return {
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    confirm: () => dispatchProps.confirm(stateProps.placeId),
    isValidAddress: () => {
      const isValid = dispatchProps.isValidAddress(
        stateProps.venueAddress1,
        stateProps.venueCity,
        stateProps.venueState,
        stateProps.venueCountry,
        stateProps.venueZip,
        stateProps.venueAddressType,
      );

      if (
        isValid &&
        stateProps.venueSearchTypeRadio === BY_SEARCH &&
        !stateProps.venueName
      ) {
        return false;
      }

      return isValid;
    },
    isValidState: () =>
      dispatchProps.isValidState(stateProps.venueState, stateProps.usStates),
    isValidVenueName: () =>
      !stateProps.venueSearchTypeRadio === BY_SEARCH || stateProps.venueName,
    setIsValidManualVenueAddress: (input) => {
      dispatchProps.setIsValidManualVenueAddress({
        ...stateProps.manualVenueAddress,
        ...input,
      });
    },
    setManualAddress: (input) =>
      dispatchProps.setManualAddress({
        ...stateProps.manualVenueAddress,
        ...input,
      }),
  };
};

const VenueContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(Venue);

export default VenueContainer;
